// extracted by mini-css-extract-plugin
export default {"hideOnPrint":"RCih2mjf0csSuDSpIxEf","showOnPrint":"G_Qu3ZuWZ5lSz5wqzXjt","termsAndConditionsContent":"MRloNJT2lVN6c35vHpQv"};